import RealizedValues from 'pages/RealizedValues';

export const realizedValuesRoutes = {
    path: '/realized-values',
    element: <RealizedValues />,
};
